import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "followup",
  "use": "followup-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"followup\">\n  <path fill=\"#000\" fill-rule=\"evenodd\" d=\"M27.238 16.864a2.5 2.5 0 0 1 3.064-1.778l47.844 12.885c.64.172 1.187.594 1.519 1.171.332.578.421 1.264.25 1.908l-12.82 48.086a2.5 2.5 0 0 1-3.064 1.778 2.516 2.516 0 0 1-1.769-3.08L73.52 35.612l-59.766 34.68a2.495 2.495 0 0 1-3.417-.92 2.521 2.521 0 0 1 .915-3.435l59.766-34.68-42.01-11.313a2.516 2.516 0 0 1-1.769-3.08Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol